export default __webpack_public_path__ + "static/media/firstEdIcon.3b38c131.png";